import { render, staticRenderFns } from "./ClassificacaoLeilao.vue?vue&type=template&id=5791c4b9"
import script from "./ClassificacaoLeilao.vue?vue&type=script&lang=js"
export * from "./ClassificacaoLeilao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports